import styled from 'styled-components'

const TABLET_BREAKPOINT = '930px'

export const ListPageWrap = styled.div`
    margin: -1rem;
    min-height: calc(100vh - 55px);
    background: #f3f4f6;
    padding: 24px;
    box-sizing: border-box;
    max-width: 100%;
    overflow-x: hidden;

    @media (max-width: ${TABLET_BREAKPOINT}) {
        margin: -0.5rem -0.75rem;
        padding: 16px 12px;
    }
`

export const ListPageInner = styled.div`
    max-width: 1240px;
    margin: 0 auto;
    width: 100%;
    min-width: 0;
`

export const PublicListWrap = styled.div`
    padding: 4px 0 32px;
`

export const BackRow = styled.div`
    padding: 0 4px 16px;
    color: #6b7280;
    font-size: 13px;

    button {
        background: none;
        border: none;
        padding: 0;
        color: #0b63ce;
        font-weight: 600;
        font-size: 13px;
        cursor: pointer;
        font-family: inherit;
    }
`

export const ListTitle = styled.h1`
    font-size: 22px;
    font-weight: 700;
    margin: 0 0 4px;
    color: #111827;
    word-break: break-word;

    @media (max-width: ${TABLET_BREAKPOINT}) {
        font-size: 18px;
    }
`

export const ListSubtitle = styled.p`
    color: #6b7280;
    margin: 0 0 20px;
    font-size: 13px;
`

export const Card = styled.div`
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
    margin-bottom: 16px;
`

export const AuditHeaderCard = styled(Card)`
    padding: 20px 22px;

    @media (max-width: ${TABLET_BREAKPOINT}) {
        padding: 16px;
    }
`

export const AuditDl = styled.dl`
    display: grid;
    grid-template-columns: 140px 1fr;
    gap: 6px 16px;
    margin: 0 0 14px;

    @media (max-width: ${TABLET_BREAKPOINT}) {
        grid-template-columns: 1fr;
        gap: 4px 0;
    }

    dt {
        color: #6b7280;
        font-size: 12px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.4px;
        margin: 0;
    }

    dd {
        margin: 0;
        font-size: 14px;
        color: #111827;
        word-break: break-word;
    }
`

export const CountRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    padding-top: 14px;
    border-top: 1px solid #e5e7eb;
`

export const StatBadge = styled.span`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 6px 12px;
    border-radius: 999px;
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    font-size: 12px;
    font-weight: 600;

    .dot {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: ${p => p.$dot || '#111827'};
    }

    .num {
        font-weight: 700;
        color: #111827;
    }

    .lbl {
        color: #6b7280;
        text-transform: uppercase;
        letter-spacing: 0.4px;
        font-size: 11px;
        font-weight: 600;
    }
`

export const FiltersCard = styled(Card)`
    padding: 14px 22px;
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    align-items: flex-end;

    @media (max-width: ${TABLET_BREAKPOINT}) {
        padding: 14px 16px;
        flex-direction: column;
        align-items: stretch;
    }
`

export const FilterField = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    flex: 0 1 auto;
    min-width: 0;

    label {
        font-size: 12px;
        color: #6b7280;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.4px;
        white-space: nowrap;
        flex-shrink: 0;
    }

    select,
    input {
        border: 1px solid #e5e7eb;
        border-radius: 6px;
        padding: 6px 10px;
        font-size: 13px;
        font-family: inherit;
        background: #fff;
        min-width: 140px;
        box-sizing: border-box;
    }

    &.grow {
        flex: 1 1 220px;
        min-width: 200px;

        input {
            width: 100%;
            min-width: 0;
        }
    }

    @media (max-width: ${TABLET_BREAKPOINT}) {
        flex: 1 1 100%;
        width: 100%;
        flex-direction: column;
        align-items: stretch;
        gap: 4px;

        label {
            white-space: normal;
        }

        select,
        input {
            width: 100%;
            min-width: 0;
        }

        &.grow {
            flex: 1 1 100%;
            min-width: 0;
        }
    }
`

export const FilterActionsGroup = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: auto;
    flex-shrink: 0;
    flex-wrap: wrap;

    @media (max-width: ${TABLET_BREAKPOINT}) {
        width: 100%;
        margin-left: 0;
        justify-content: flex-end;
    }
`

export const FilterBtn = styled.button`
    background: ${p => (p.$ghost ? 'transparent' : '#0b63ce')};
    color: ${p => (p.$ghost ? '#0b63ce' : '#fff')};
    border: 1px solid ${p => (p.$ghost ? '#e5e7eb' : '#0b63ce')};
    border-radius: 6px;
    padding: 7px 14px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    font-family: inherit;

    &:hover {
        background: ${p => (p.$ghost ? '#f9fafb' : '#0950a8')};
    }
`

export const TicketListCard = styled(Card)`
    padding: 0;
    overflow: hidden;
    max-width: 100%;
`

export const TicketTableScroll = styled.div`
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
`

export const TicketTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    min-width: 760px;

    thead th {
        text-align: left;
        font-size: 11px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        color: #6b7280;
        font-weight: 700;
        padding: 12px 16px;
        background: #f9fafb;
        border-bottom: 1px solid #e5e7eb;
        white-space: nowrap;
    }

    tbody td {
        padding: 14px 16px;
        border-bottom: 1px solid #e5e7eb;
        vertical-align: top;
        font-size: 13.5px;
    }

    tbody tr {
        cursor: pointer;

        &:hover {
            background: #f9fafb;
        }

        &:last-child td {
            border-bottom: none;
        }
    }
`

export const TicketMobileList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 12px;
`

export const TicketMobileCard = styled.button`
    display: block;
    width: 100%;
    text-align: left;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 8px;
    padding: 14px;
    cursor: pointer;
    font-family: inherit;
    box-sizing: border-box;

    &:hover {
        background: #f9fafb;
    }
`

export const MobileCardTop = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 10px;
    margin-bottom: 8px;
`

export const MobileCardId = styled.span`
    font-size: 14px;
    font-weight: 700;
    color: #111827;
    flex-shrink: 0;
`

export const MobileCardArrow = styled.span`
    color: #0b63ce;
    font-size: 18px;
    font-weight: 700;
    flex-shrink: 0;
`

export const MobileCardMeta = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: center;
    margin-bottom: 8px;
`

export const MobileCardFooter = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 10px;
    font-size: 12px;
    color: #6b7280;
    flex-wrap: wrap;
`

export const ColId = styled.td`
    width: 72px;
    font-weight: 700;
`

export const PriorityPill = styled.span`
    display: inline-flex;
    align-items: center;
    padding: 3px 10px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: #fff;
    background: ${p => {
        switch (p.$pill) {
            case 'critical':
                return '#dc2626'
            case 'high':
                return '#ea580c'
            case 'medium':
                return '#d97706'
            default:
                return '#6b7280'
        }
    }};
`

export const QuestionCell = styled.div`
    min-width: 0;

    .q {
        color: #111827;
        line-height: 1.5;
        word-break: break-word;
    }

    .a {
        display: inline-block;
        margin-top: 4px;
        padding: 2px 8px;
        border-radius: 4px;
        background: #fef2f2;
        color: #b91c1c;
        font-weight: 600;
        font-size: 12.5px;
        word-break: break-word;
    }
`

export const StatusBadge = styled.span`
    display: inline-block;
    padding: 3px 10px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 600;
    background: ${p => {
        switch (p.$pill) {
            case 'progress':
                return '#fef3c7'
            case 'resolved':
                return '#dcfce7'
            case 'closed':
                return '#e5e7eb'
            case 'ack':
                return '#dbeafe'
            case 'pending':
                return '#f5f3ff'
            case 'cancelled':
                return '#f4f4f5'
            case 'escalated':
                return '#ffedd5'
            case 'hold':
                return '#f3e8ff'
            case 'open':
                return '#f1f5f9'
            default:
                return '#dbeafe'
        }
    }};
    color: ${p => {
        switch (p.$pill) {
            case 'progress':
                return '#92400e'
            case 'resolved':
                return '#166534'
            case 'closed':
            case 'cancelled':
                return '#374151'
            case 'pending':
                return '#5b21b6'
            case 'escalated':
                return '#c2410c'
            case 'hold':
                return '#6d28d9'
            case 'open':
                return '#334155'
            default:
                return '#1d4ed8'
        }
    }};
`

export const WhenText = styled.span`
    display: block;
    font-size: 11px;
    color: #6b7280;
    margin-top: 3px;
`

export const AssigneeCell = styled.div`
    font-size: 13px;
    min-width: 0;
    word-break: break-word;

    .email {
        display: block;
        font-size: 11px;
        color: #6b7280;
        margin-top: 2px;
        word-break: break-all;
    }
`

export const RowAction = styled.td`
    width: 60px;
    text-align: right;
    color: #0b63ce;
    font-size: 18px;
    font-weight: 700;
`

export const Pager = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 22px;
    color: #6b7280;
    font-size: 13px;
    flex-wrap: wrap;
    gap: 12px;

    .right {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;
    }

    button {
        border: 1px solid #e5e7eb;
        background: #fff;
        border-radius: 6px;
        padding: 5px 10px;
        font-size: 13px;
        cursor: pointer;
        font-family: inherit;

        &:disabled {
            color: #9ca3af;
            cursor: not-allowed;
        }
    }

    select {
        border: 1px solid #e5e7eb;
        border-radius: 6px;
        padding: 5px 8px;
        font-size: 13px;
        background: #fff;
        max-width: 100%;
    }

    @media (max-width: ${TABLET_BREAKPOINT}) {
        padding: 14px 16px;
        flex-direction: column;
        align-items: stretch;

        .right {
            justify-content: center;
        }
    }
`

export const EmptyCard = styled(Card)`
    padding: 32px 22px;
    text-align: center;
    color: #6b7280;

    h2 {
        margin: 0 0 8px;
        font-size: 16px;
        color: #111827;
    }

    p {
        margin: 0;
        font-size: 14px;
    }
`

export const ErrorText = styled.p`
    color: #b91c1c;
    font-size: 14px;
    margin: 0 0 16px;
`
